export enum LayoutType {
    BLANK = 'BLANK',
    ADMIN = 'ADMIN',
}

export enum SOURCE_PAGE {
    PMS = 'pms',
    POS = 'pos',
}
